import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const mobileAppsSlice = createApi({
  reducerPath: 'mobileAppsSlice',
  baseQuery,
  endpoints: (builder) => ({
    getMobileAppsGroupedStats: builder.query({
      query: ({ apiManager, ...rest }) => apiManager.getGroupedStats(rest),
    }),
    getMobileAppsStats: builder.query({
      query: ({ apiManager, ...rest }) => apiManager.getStats(rest),
    }),
  }),
  serializeQueryArgs,
});

export const { useGetMobileAppsGroupedStatsQuery, useGetMobileAppsStatsQuery } = mobileAppsSlice;
